<div [ngClass]="{ active: isActive }" class="card-area card">
  <div class="avatar-wrapper background-loading-tiny">
    <img [src]="user?.imageUrl" alt="user-image" appDefaultImage="assets/images/placeholder.png" loading="lazy" />
    @if (isActive) {
      <div class="gift-circle">
        <app-icon iconName="gift" size="12px"></app-icon>
      </div>
    }
  </div>
  @if (isActive) {
    <h2 class="surprise-text mt-16">Hi, {{ currentUsername | humanize }}!</h2>
  }
  @if (isActive) {
    <p class="surprise-text">{{ 'Today is' | translate }} {{ user?.fullName | humanize }}'s {{ (user?.isBirthday && !user?.isJubilee ? 'Birthday' : 'Anniversary') | translate }}!</p>
  }

  @if (!isActive) {
    <h2 class="avatar-title mt-12">{{ user?.fullName }}</h2>
  }
  @if (!isActive) {
    <small class="avatar-day-type">{{ (user?.isBirthday && !user?.isJubilee ? 'Birthday' : 'Anniversary') | translate }}</small>
  }
  @if (!isActive) {
    <h4 class="avatar-text mt-6">🎉 {{ age }} {{ (user.isJubilee && !user.isBirthday ? 'years in club' : 'years') | translate }}</h4>
  }

  <!-- progress-bar.component.html -->
  <div [ngClass]="{ hidden: isActive }" class="progress">
    <div [style.opacity]="1" [style.width.%]="progressPercentageByCalculatingRemainingDays" class="progress-done"></div>
  </div>

  @if (isActive) {
    <button (click)="navigateToChat()" class="button button-simple button-small mt-22 congrats-button">{{ 'Say Congrats' | translate }} 🎉</button>
  }

  @if (!isActive) {
    <p class="days-text mt-12">{{ remainingDays }}</p>
  }
</div>
